import { createAction } from '@reduxjs/toolkit';

export const clearChatHistory = createAction('chatbot/clearChatHistory');
export const reloadChatbot = createAction('chatbot/reloadChatbot');
